import Vue from 'vue'

Vue.component('full-container', () => import('./full-container.vue'))